function aMediator(entry, code) {

    const session = localStorage.getItem("session");
    if(session){
        if(entry == "start"){
            window.location = `/dashboard`;
        }
        else if(entry == "contact"){
            window.location = `/contact?type=lead&item=`;
        }
        else if(entry == "payment"){
            window.location = `/payment/pay/${code}?p=upgrade`;
        }
        else if(entry == "job-application"){
            window.location = `/job/${code}`;
        }
        
    }else{
        window.location = `/login/${entry}`;
    }

}

export default aMediator